<template>
  <van-tabbar v-model="active">
    <van-tabbar-item
      replace
      :to="item.path"
      :name="item.name"
      v-for="item in navs"
      :key="item.name"
    >
      <span>{{ item.meta.title }}</span>
      <template #icon="props">
        <i
          class="lw-icon"
          v-html="itemName == item.name ? item.meta.activeIcon : item.meta.icon"
        ></i>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import router from "@/router/routes";
export default {
  data() {
    return {
      navs: [],
      itemName: "",
      active: "",
      isIosbtm: true,
    };
  },
  created() {
    this.navs = router.filter((item) => item.meta.isTabbar === true);
    this.active = this.$route.name;
  },
};
</script>

<style scoped>
i {
  display: block;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.4rem;
}
span {
  font-size: 0.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
}
.router-link-exact-active,
.router-link-active {
  color: #228ef7;
}
</style>
